<template>
  <div
    :class="[
      'main-navbar',
      'bg-primary',
      stickyTop ? 'sticky-top' : 'fixed-top',
    ]"
  >
    <d-navbar
      type="light"
      :class="[
        'd-flex ',
        userLogged ? 'justify-content-end' : 'justify-content-start',
        'flex-md-nowrap',
        'p-0',
      ]"
    >
      <logo v-if="!userLogged" />
      <div v-else class="d-flex w-100 justify-content-between">
        <navbar-toggle /> <navbar-nav />
      </div>
    </d-navbar>
  </div>
</template>

<script>
import Logo from './Logo.vue';
import NavbarNav from './NavbarNav.vue';
import NavbarToggle from './NavbarToggle.vue';

export default {
  components: {
    Logo,
    NavbarNav,
    NavbarToggle,
  },
  computed: {
    userLogged() {
      const { user } = this.$store.state.user;
      if (user) {
        return true;
      }
      return false;
    },
  },
  props: {
    /**
     * Whether the main navbar should be sticky, or not.
     */
    stickyTop: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss">
.main-navbar {
  .dropdown-menu {
    display: block;
  }
}
</style>
